// Avisos ANTES de cobrar (informe del dueño D3/D10/D11): detecta condiciones que suelen
// hacer fallar la generación para advertir al usuario antes de consumir créditos.

const MULTI_PERSON = [
  "pareja", "parejas", "novia", "novio", "esposa", "esposo", "familia", "familiar",
  "hijos", "hija", "hijo", "amigos", "grupo", "multitud", "gente", "personas", "ambos",
  "ellos", "ellas", "abrazo", "abrazan", "besan", "beso", "bailan juntos", "dos hombres",
  "dos mujeres", "hombre y mujer", "mujer y hombre", "couple", "family", "crowd", "group",
  "they ", "two people", "man and woman", "woman and man", "kiss", "hug",
];

export function detectMultiPerson(text) {
  const t = (text || "").toLowerCase();
  return MULTI_PERSON.some((k) => t.includes(k));
}

// Devuelve la lista de avisos para un flujo de video/corto.
// opts: { hasCharacter, prompt, duration, quality }
export function preflightWarnings({ hasCharacter, prompt, duration, quality }) {
  const w = [];
  if (!hasCharacter) {
    w.push("Vas a generar SIN personaje fijo: la cara puede variar entre escenas.");
  }
  if (detectMultiPerson(prompt)) {
    w.push("El prompt describe varias personas o una pareja: el modelo puede fallar o animar solo un retrato. Revisa el resultado antes de gastar más.");
  }
  if (String(duration) === "10") {
    w.push("Según el motor, algunas escenas de 10s pueden entregarse en 6s (tope del modelo).");
  }
  return w;
}
